import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const GetAdEventsCountsRequest = z.object({
  adIds: z.array(z.string().uuid()),
})
export type GetAdEventsCountsRequest = z.infer<typeof GetAdEventsCountsRequest>

export const AdEventCounts = z.object({
  adId: z.string().uuid(),
  recommendation: z.number(),
  impression: z.number(),
  engagement: z.number(),
})
export type AdEventCounts = z.infer<typeof AdEventCounts>

export const GetAdEventsCountsResponse = z.object({
  counts: z.array(AdEventCounts),
})
export type GetAdEventsCountsResponse = z.infer<typeof GetAdEventsCountsResponse>

export const getAdEventsCountsDeclaration = endpointDeclaration(GetAdEventsCountsRequest, GetAdEventsCountsResponse)
